let panier = [];
let listAutoDiscount = [];
let initDiscount = false;
const listItemProductCard = document.getElementById('list-cart-items')
const totalPriceCart = document.getElementById('total-product-cart')
const allCart = document.querySelectorAll('.target-cart-icone')
const targetCartPage = document.getElementById('cart-side-modal')
const closeSideCart = document.getElementById('close-btn-cart-side')
const overlayGeneral = document.getElementById('overlay-page')
const btnCodeDiscount = document.getElementById("discount-form");
const allPriceOnPage = document.querySelectorAll('.target-price-discount')
const countItemCart = document.querySelectorAll('.target-count-items-cart')
const strCountCart = document.querySelector('.target-articles-string-count')
const priceDynamic = document.querySelectorAll('.dom-price-dynam')
const bodyTargetAll = document.querySelector('body');
const updateTimers = {};
const assetsCart = themeAssetsCart;
const storageDiscount = "cartDiscountCode"
const baseApi = "https://appgeniux.fr";
const shopName = 'shop1'


const initAppStandard = {
    formatPrice: (cents) => {
        let value = "";
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

        function formatWithDelimiters(number, precision = 2, thousands = " ", decimal = ",") {
            if (isNaN(number) || number == null) return 0;

            number = (number / 100.0).toFixed(precision);

            const parts = number.split(".");
            let dollars = parts[0];
            const cents = parts[1] ? parts[1] : "";

            const regex = /(\d)(?=(\d\d\d)+(?!\d))/g;
            dollars = dollars.replace(regex, "$1" + thousands);

            return cents ? dollars + decimal + cents : dollars;
        }

        switch (shopifyCurrencyFormat.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                value = formatWithDelimiters(cents, 2, "'", ".");
                break;
        }

        return shopifyCurrencyFormat.replace(placeholderRegex, value);
    },
    setPriceDiscount: async () => {
        if (allPriceOnPage?.length > 0) {
            try {
                const res = await fetch(baseApi + '/list-automatic-discounts?shop=' + shopName);
                const discounts = await res.json();

                allPriceOnPage.forEach(el => {
                    const basePriceCents = parseInt(el.dataset.price, 10); // 799 => 7,99€

                    let collections = [];
                    try {
                        collections = JSON.parse(el.dataset.collections || "[]");
                    } catch (e) {
                        console.warn("⚠️ Impossible de parser data-collections", e);
                    }

                    let newPriceCents = basePriceCents;
                    let hasDiscount = false;
                    let discountLabel = "";

                    discounts.forEach(d => {
                        if (d.scope === "collections" && collections?.length > 0) {
                            const match = collections.some(c =>
                                d.collections.some(dc => String(dc.id).includes(c.id))
                            );
                            if (match) {
                                if (d.value_type === "percentage") {
                                    newPriceCents = Math.ceil(basePriceCents * (1 - d.value / 100));
                                    discountLabel = `-${d.value}%`;
                                } else if (d.value_type === "fixed_amount") {
                                    newPriceCents = Math.ceil(basePriceCents - (d.value * 100));
                                    discountLabel = `-${d.value} ${d.currency || "€"}`;
                                }
                                hasDiscount = true;
                            }
                        }

                        if (d.scope === "order") {
                            if (d.value_type === "percentage") {
                                newPriceCents = Math.ceil(basePriceCents * (1 - d.value / 100));
                                discountLabel = `-${d.value}%`;
                            } else if (d.value_type === "fixed_amount") {
                                newPriceCents = Math.ceil(basePriceCents - (d.value * 100));
                                discountLabel = `-${d.value} ${d.currency || "€"}`;
                            }
                            hasDiscount = true;
                        }
                    });

                    if (hasDiscount) {
                        el.innerHTML = `
                        ${initAppStandard.formatPrice(newPriceCents)}
                        <span class="old-price-container">
                            <em class="old-price">${initAppStandard.formatPrice(basePriceCents)}</em>
                            <em class="percent-discount-change">${discountLabel}</em>
                        </span>
                    `;
                    }
                });
            } catch (err) {
                console.error("❌ Error fetching discounts", err);
            }
        }
    },
    cart: async () => {
        const cart = await fetch('/cart.js', {
            headers: { 'Accept': 'application/json' }
        }).then(r => r.json());


        if (cart?.items?.length > 0) {
            listItemProductCard.innerHTML = ''
            const items = cart.items
            const item_count = cart.item_count;
            const total_price = cart.total_price
            const total_brut = cart.original_total_price;
            const total_discount = cart.total_discount;
            const listDiscountCode = cart.discount_codes;
            const remise_percent = total_discount ? Math.round((total_discount / (total_price + total_discount)) * 100) : 0;

            let html = "";

            items.forEach(element => {
                const options_with_values = element.options_with_values;
                const product_title = element.product_title;
                const price = initAppStandard.formatPrice(element.price);
                const finalPrice = initAppStandard.formatPrice(element.final_line_price);
                const getDiscount = element.discounts;

                const discount = element.total_discount ? initAppStandard.formatPrice(element.total_discount) : 0;
                const quantity = element.quantity;
                const totalPrice = initAppStandard.formatPrice(quantity * element.price)
                const image = element.image;
                const url = element.url;
                const id = element.id;
                const variant_id = element.variant_id
                html += `<div class="line-product-cart">
                    <a class="line-prooduct-img" href="${url}">
                        <img src="${image}" alt="${product_title}" />
                    </a>
                    <div class="head-title-product-cart">
                        <div class="head-info-product-cart">
                            <div>
                                <p>${product_title}</p>
                                ${options_with_values?.length > 0 && `<div class="list-option-item-cart">`}
                                ${options_with_values.map((e, i) => (
                    `<span class="option-item-cart">${e.value} ${i + 1 !== options_with_values.length ? "/" : ""} </span> `
                ))}
                                ${options_with_values?.length > 0 && `</div>`}
                            </div>
                            <button data-id="${id}" style="min-width:32px" class="btn-delete-item-cart">
                                <img src="${assetsCart.delete}" height="20" width="20" />
                            </button>
                        </div>
                        ${getDiscount?.length > 0 ? ` <div>
                                <div class="line-discount-info-soft">
                                    <img src="${assetsCart.discount}" height="18" width="18" />${getDiscount[0].title} (<em>-${initAppStandard.formatPrice(getDiscount[0].amount)}</em>)
                                </div>
                            </div>` : ''}
                        <div class="head-info-product-cart">
                            <div data-id="${id}" data-vid="${variant_id}" class="quantity-selector" style="display: flex; align-items: center;">
                                <button type="button"data-action="-"  class="qty-cta-cart qty-item-decrease">-</button>
                                <input class="target-input-qty-cart" type="number" name="quantity" min="1" value="${quantity}" style="width: 50px; text-align: center;">
                                <button type="button" data-action="+"  class="qty-cta-cart qty-item-increase">+</button>
                            </div>    
                            <div class="info-price-cart">
                                ${discount ? `<p class="price-product-cart bar">${totalPrice}</p>` : ""}
                                <p class="price-product-cart">${finalPrice}</p>
                            </div>
                            
                        </div>
                    </div>
                </div>
                `
            });
            html += `  <div class="sticky-indicator-down-cart">
                        <p>
                            Défiler vers le bas
                            <img height="8" width="8" src="${assetsCart.arrowDownWhite}" alt="icone arrow"> 
                        </p>
                </div>`
            if (listItemProductCard) {
                listItemProductCard.innerHTML = html;
            }
            if (priceDynamic?.length > 0) {
                priceDynamic.forEach(e => e.innerText = initAppStandard.formatPrice(total_price))
            }
            if (totalPriceCart) {
                let htmlTotalPrice = `<div class="total-cart-product">`
                if (total_discount) {
                    htmlTotalPrice += `<div class="line-total-min-cart">
                        <p>Total avant réduction</p>
                        <p class="target-price-cart-loaded"><span>${initAppStandard.formatPrice(total_brut)}</span></p>
                    </div>`
                    htmlTotalPrice += `<div class="line-total-min-cart"> 
                        <div>
                            <p>Remise</p>
                            <div >
                                ${listDiscountCode?.length > 0 ? `<div class="line-discount-info">
                                    <img src="${assetsCart.discount}" height="18" width="18" />-${remise_percent}% de remise <button class="remise-close-cart"></button>
                                </div>`: ""}
                            </div>
                        </div>
                        <p class="target-price-cart-loaded"><span>-${initAppStandard.formatPrice(total_discount)}</span></p>
                    </div>`
                }
                htmlTotalPrice += `<div class="line-total-cart-product">
                        <p>Total</p>
                        <p class="target-price-cart-loaded"><span>${initAppStandard.formatPrice(total_price)}</span></p>
                    </div>
                </div>`
                totalPriceCart.innerHTML = htmlTotalPrice
            }
            if (strCountCart) {
                strCountCart.innerText = countItemCart?.length > 1 ? "Articles" : "Article"
            }
            if (countItemCart?.length > 0) {
                countItemCart.forEach(e => {
                    e.classList.add('fill')
                    e.innerText = item_count
                })

            }
            initAppStandard.cartListenBtn();
        } else {
            const getUrlLink = listItemProductCard.dataset.link
            listItemProductCard.innerHTML = `<div class="empty-cart">
                <p>Votre panier est vide</p>
                <a href="${getUrlLink}"> Découvrir nos produitss</a>
             </div>`
             totalPriceCart.innerHTML = ``
              if (countItemCart?.length > 0) {
                countItemCart.forEach(e => {
                    e.classList.remove('fill')
                    e.innerText = 0
                })
            }
             if (priceDynamic?.length > 0) {
                priceDynamic.forEach(e => e.innerText = initAppStandard.formatPrice(0))
            }
        }
        initAppStandard.cartDefilement();
    },
    cartListenBtn: () => {
        const btnDelete = document.querySelectorAll('.btn-delete-item-cart');
        const btnAdd = document.querySelectorAll('.qty-cta-cart')


        if (btnDelete?.length > 0) {
            btnDelete.forEach(el => {
                el.addEventListener('click', () => {
                    const parent = el.parentNode.parentNode;
                    parent.classList.add('load')
                    initAppStandard.loadPriceTotal(true)
                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            id: el.dataset.id, // l'ID unique de la ligne du panier
                            quantity: 0
                        })
                    })
                        .then(response => response.json())
                        .then(cart => {
                            initAppStandard.cart()
                        })
                        .catch(error => {
                            initAppStandard.loadPriceTotal(false)
                            parent.classList.remove('load')
                            console.error('Erreur lors de la suppression :', error);
                        });
                })
            })
        }

        if (btnAdd?.length > 0) {
            [...btnAdd].forEach((e, line) => {
                e.addEventListener('click', () => {
                    const parentAll = e.parentNode.parentNode;
                    const targetInput = e.parentNode.querySelector('.target-input-qty-cart');
                    const action = e.dataset.action;
                    const variant_id = e.parentNode.dataset.vid;
                    const value = targetInput.value;
                    let newValue = action == "+" ? parseInt(value) + 1 : parseInt(value) - 1;
                    if (newValue <= 0) {
                        newValue = 1;
                    }
                    targetInput.value = newValue

                    /** CALL MAJ CART */
                    clearTimeout(updateTimers[variant_id]);
                    updateTimers[variant_id] = setTimeout(async () => {
                        parentAll.classList.add('load')
                        initAppStandard.loadPriceTotal()
                        await initAppStandard.updateCartQuantity(variant_id, newValue);
                        initAppStandard.cart()
                    }, 500);
                })
            })
        }
    },
    cartDefilement: () => {
        if (listItemProductCard) {
            if (listItemProductCard.scrollWidth > listItemProductCard.clientWidth || listItemProductCard.scrollHeight > listItemProductCard.clientHeight) {
                listItemProductCard.classList.add('defilement')
            } else {
                listItemProductCard.classList.remove('defilement')
            }
        }
    },
    updateCartQuantity: async (variantId, quantity) => {
        try {
            const res = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    updates: {
                        [variantId]: quantity // variantId : quantité
                    }
                })
            });

            if (!res.ok) {
                throw new Error("Erreur HTTP : " + res.status);
            }
            return true;
        } catch (err) {
            console.error("❌ Erreur maj panier :", err);
            throw err;
        }
    },
    loadPriceTotal: (b = true) => {
        const targetTotalPrice = document.querySelectorAll('.target-price-cart-loaded');
        if (targetTotalPrice?.length > 0) {
            [...targetTotalPrice].forEach(e => b ? e.classList.add('load') : e.classList.remove('load'))
        }
    },
    getDiscountAuto: async () => {
        /** INIT DISCOUNT */
        if (!initDiscount) {
            initDiscount = true;
            const getDiscount = await fetch(baseApi + "/list-automatic-discounts?shop=" + shopName).then(r => r.json())
            if (getDiscount?.length > 0) {
                listAutoDiscount = getDiscount;
            }
        }

        if (listAutoDiscount?.length > 0) {

        }
    },
    checkCodePromo: async (code) => {

        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
        document.body.appendChild(iframe);

        iframe.onload = () => {
            initAppStandard.cart();
            iframe.remove()
            console.log(`Code promo ${code} appliqué ! 🎉`);
            // tu peux notifier l'utilisateur ici
        };
    },
    removeCodePromo: async () => {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = `/discount/remove?redirect=/checkout`;
        document.body.appendChild(iframe);

        iframe.onload = () => {
            initAppStandard.cart();
            iframe.remove()
            console.log("Code promo supprimé ❌");
            // notifier l'utilisateur ici aussi si tu veux
        };
    },
    domListerner: () => {
        if (allCart?.length > 0) {
            allCart.forEach(el => {
                el.addEventListener('click', () => {
                    if (targetCartPage) {
                        targetCartPage.classList.add('active')
                        overlayGeneral.classList.add('active-black-desk')
                        initAppStandard.getDiscountAuto();
                        bodyTargetAll.style.overflowY = "hidden"
                    }
                })
            })
        }
        if (closeSideCart) {
            closeSideCart.addEventListener('click', () => {
                if (targetCartPage) {
                    targetCartPage.classList.remove('active')
                    overlayGeneral.classList.remove('active-black-desk')
                    bodyTargetAll.style.overflowY = "scroll"
                }
            })
        }
        if (overlayGeneral) {
            overlayGeneral.addEventListener('click', () => {
                if (targetCartPage && overlayGeneral.classList.contains('active-black-desk')) {
                    overlayGeneral.classList.remove('active-black-desk')
                    targetCartPage.classList.remove('active')
                    bodyTargetAll.style.overflowY = "scroll"
                }
            })
        }
        if (btnCodeDiscount) {
            btnCodeDiscount.addEventListener("submit", async (e) => {
                e.preventDefault(); // éviter le reload

                const input = document.getElementById("cart-discount-input");
                const code = (input.value || "").trim().toUpperCase();
                if (!code) {
                    return;
                }
                const valid = await initAppStandard.checkCodePromo(code);
                if (valid) {
                    localStorage.setItem(storageDiscount, code);
                } else {
                    localStorage.removeItem(storageDiscount);
                }
            });
        }
        if (listItemProductCard) {
            listItemProductCard.addEventListener('scroll', (e) => {
                const el = e.target;
                if (el.scrollTop > 10) {
                    el.classList.remove('defilement')
                } else {
                    el.classList.add('defilement')
                }
            })
        }

    },
    init: () => {

        initAppStandard.setPriceDiscount();
        initAppStandard.cart()
        initAppStandard.domListerner();
    }
}

initAppStandard.init()